import { getAmpConfigFlags } from 'src/services/amp-config.service';
import authService from 'src/services/api/auth.service';
import { loggerService } from 'src/services/logger.service';
import { useGetStudentAssignmentsQuery } from 'src/store/api/assignment';
import {
  useActiveMSAssignmentsStatus,
  useActiveMSAssignmentsSubject,
  useCurrentAppViewSelector,
} from 'src/store/features';

import { useIsMiddleSchoolView } from '../use-is-middle-school-view';

// TODO: Remove after RFS.
export const useMSStudentAssignments = () => {
  const activeMSAssignmentsStatus = useActiveMSAssignmentsStatus();
  const activeMSAssignmentsSubject = useActiveMSAssignmentsSubject();
  const isMiddleSchoolView = useIsMiddleSchoolView();
  const currentAppView = useCurrentAppViewSelector();

  const isTeacher = authService.isTeacher();

  const isUpdatedMSViewEnabled = getAmpConfigFlags().isUpdatedMSViewEnabled;

  const shouldSkipQuery =
    isTeacher ||
    currentAppView === null ||
    !isMiddleSchoolView ||
    isUpdatedMSViewEnabled;

  const studentAssignmentsQueryParams = {
    showContentStatuses: activeMSAssignmentsStatus,
    includeSingleSessionCodes: true,
  };

  const queryResult = useGetStudentAssignmentsQuery(
    {
      domain: activeMSAssignmentsSubject,
      ...studentAssignmentsQueryParams,
    },
    {
      skip: shouldSkipQuery,
    },
  );

  if (queryResult.error) {
    loggerService.logError(
      'Something went wrong during MS student assignments query',
      queryResult.error,
    );
  }

  return queryResult;
};
